import { render, staticRenderFns } from "./ShipmentStatusBadge.vue?vue&type=template&id=59ae8266&scoped=true"
import script from "./ShipmentStatusBadge.vue?vue&type=script&lang=js"
export * from "./ShipmentStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./ShipmentStatusBadge.vue?vue&type=style&index=0&id=59ae8266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ae8266",
  null
  
)

export default component.exports